export default "__VITE_ASSET__CXj5IcNR__"